import { render, staticRenderFns } from "./Multiselect.vue?vue&type=template&id=64c1fcda&"
import script from "./Multiselect.vue?vue&type=script&lang=js&"
export * from "./Multiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports